module.exports = __webpack_public_path__ + "img/growth-analytics.5907b9c3.svg";